(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('UploadModalBoothSetupController', UploadModalBoothSetupController);

    UploadModalBoothSetupController.$inject = ['$uibModalInstance', 'boothItem', 'VirtualFairService', '$rootScope','$scope', '$sce', 'FileUploader', 'toastr'];

    function UploadModalBoothSetupController($uibModalInstance, boothItem, VirtualFairService, $rootScope, $scope, $sce, FileUploader, toastr) {
        var vm = this;

        vm.boothItem       = boothItem;
        vm.registered      = '';
        vm.imgPath         = '';
        vm.files           = '';
        vm.query           = [];
        vm.photos          = [];
        vm.ok              = ok;
        vm.cancel          = cancel;

        activate();

        $scope.trustSrc = function(src) {
            return $sce.trustAsResourceUrl(src);
        }

        function activate() {
            if(vm.boothItem.booths[0].has_final_booth)
                vm.imgPath = vm.boothItem.booths[0].final_booth;

            var token = localStorage.getItem('id_token');

            var tokenHeader = 'Bearer ' + token;
            $scope.uploader = new FileUploader({

                url:'/api/v1/virtualfairs/booth-setup/upload',
                withCredentials: false,
                method: 'POST',
                file:vm.files,
                formData : [{
                    'id'                                     : vm.boothItem.id,
                    'user_id'                                : vm.boothItem.user_id,
                    'nick'                                   : vm.boothItem.nick,
                    'type'                                   : vm.boothItem.type,
                    'booth_expo_virtual_fair_booth_model_id' : vm.boothItem.booths[0].booth_expo_virtual_fair_booth_model_id,
                    'booth_expo_user_virtual_fair_id'        : vm.boothItem.booths[0].booth_expo_user_virtual_fair_id,
                }],
                headers: {
                    'Authorization': 'Bearer ' + tokenHeader
                },
                onCompleteItem: function(item, response, status, headers) {

                    if(response.status) {
                        vm.imgPath = response.url;
                        toastr.success(response.message);
                    } else {
                        toastr.error(response.message);
                    }
                }
            });
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

    }

})();